class YouMayAlsoLike extends HTMLElement {
  constructor() {
    super();

    this.stage = this.querySelector('.you-may-also-like-widget__stage');
    this.slides = this.stage ? Array.from(this.stage.querySelectorAll('.you-may-also-like-slide')) : [];
    this.interval = parseInt(this.dataset.interval, 10) || 60000;
    this.currentIndex = null;
    this.transitioning = false;

    if (this.slides.length === 0) return;

    this.addEventListener('change', this.onSizeChange.bind(this));

    this.showInitial();
    this.timer = window.setInterval(this.rotate.bind(this), this.interval);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
  }

  onSizeChange(event) {
    if (!event.target.matches('[data-you-may-also-like-size]')) return;
    const slide = event.target.closest('.you-may-also-like-slide');
    if (!slide) return;
    const variantIdInput = slide.querySelector('.product-variant-id');
    if (variantIdInput) variantIdInput.value = event.target.value;
  }

  pickRandomIndex(excludeIndex) {
    if (this.slides.length === 1) return 0;
    let index;
    do {
      index = Math.floor(Math.random() * this.slides.length);
    } while (index === excludeIndex);
    return index;
  }

  showInitial() {
    const index = this.pickRandomIndex(null);
    const slide = this.slides[index];
    slide.hidden = false;
    slide.classList.add('you-may-also-like-slide--active');
    this.currentIndex = index;
  }

  rotate() {
    if (this.transitioning || this.slides.length < 2) return;
    this.transitioning = true;

    const nextIndex = this.pickRandomIndex(this.currentIndex);
    const current = this.slides[this.currentIndex];
    const next = this.slides[nextIndex];

    this.stage.style.minHeight = `${current.offsetHeight}px`;

    current.classList.add('you-may-also-like-slide--overlay');
    next.hidden = false;
    next.classList.add('you-may-also-like-slide--overlay');

    // Force layout so the browser registers the starting opacity before we
    // transition, otherwise the fade-in has nothing to animate from.
    void next.offsetWidth;

    current.classList.add('you-may-also-like-slide--fading-out');
    next.classList.add('you-may-also-like-slide--active');

    const finish = () => {
      current.removeEventListener('transitionend', finish);
      current.hidden = true;
      current.classList.remove(
        'you-may-also-like-slide--active',
        'you-may-also-like-slide--fading-out',
        'you-may-also-like-slide--overlay'
      );
      next.classList.remove('you-may-also-like-slide--overlay');
      this.stage.style.minHeight = '';
      this.currentIndex = nextIndex;
      this.transitioning = false;
    };

    current.addEventListener('transitionend', finish, { once: true });
  }
}

customElements.define('you-may-also-like', YouMayAlsoLike);
